import React, { useCallback, useEffect, useState } from "react";
import SelectBox from "../../../components/SelectBox";
import useAppContext from "../../../utils/Reducers";
import Rec_Cam from "../../../images/Rec_Cam.png";
import Connect_Cam from "../../../images/reconnect.png";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Button } from "react-bootstrap";

const SearchBar = (props) => {
  // SerachBar 기본 필드
  const {
    store: { userInfo },
  } = useAppContext();

  const [recording, setRecording] = useState(false);
  //코드 및 그리드 초기화 및 생성

  useEffect(() => {
    props.recordingValue.find(
      (value) => value.scrapAreaCd === props.primaryParameters.schScrapAreaCd
    )
      ? setRecording(true)
      : setRecording(false);
  }, [props.recordingValue]);

  return (
    <>
      <div className="searchdata">
        <ul className="clear">
          <li style={{ width: "350px" }}>
            <div className="divide50">
              <font color="grey">⦁</font> 사업장구분
            </div>
            <SelectBox
              mastCd="PLANT_CD"
              id="schPlantCd"
              name="schPlantCd"
              topSelected="전체"
              attr10="Y"
              onChange={props.handleChangeField}
              value={props.primaryParameters.schPlantCd}
              className="datainput"
              style={{ width: "200px" }}
            />
          </li>

          <li style={{ width: "350px" }}>
            <img
              src={Rec_Cam}
              style={{ width: "33px", height: "33px", paddingRight: "10px" }}
            />

            <div className="div_50">CCTV 실시간 확인</div>
            <div className="div_50">수동녹화</div>
            <div className="direction">
              <div className="manual">
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id="tooltip1">영상녹화시작</Tooltip>}
                >
                  <button
                    type="button"
                    onClick={props.onCameraStart}
                    className={recording ? "voff" : "video"}
                    id="video"
                    disabled={recording}
                    value="rec"
                  ></button>
                </OverlayTrigger>
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id="tooltip2">영상녹화중지</Tooltip>}
                >
                  <button
                    type="button"
                    onClick={props.onCameraStop}
                    className={recording ? "videoclose" : "videocloseoff"}
                    id="videoclose"
                    disabled={!recording}
                    value="stop"
                  ></button>
                </OverlayTrigger>
              </div>
            </div>
          </li>
          <li style={{ width: "350px" }}>
            <div className="div_50">카메라 다시 연결</div>
            <div className="direction">
              <div className="manual">
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id="tooltip1">카메라 다시 연결</Tooltip>}
                >
                  <button
                    type="button"
                    onClick={props.onReconnectCamera}
                    className="connect"
                    id="connect"
                    value="rec"
                  ></button>
                </OverlayTrigger>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </>
  );
};

export default React.memo(SearchBar);
